module.exports = __webpack_public_path__ + "img/CalendarIcon.32e0339d.png";